import { values } from 'lodash-es';

import type { LookoRouteObject } from '@/router/LookoRouteObject';

export const 쇼핑몰_연동_설정_페이지_라우터 = {
  index: {
    path: '/settings/market-linkage',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/쇼핑몰_연동_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '쇼핑몰 설정',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  카페24_연동하기_페이지: {
    path: '/settings/market-linkage/cafe24/login',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/cafe24/카페24_연동하기_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '카페24 연동하기',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  네이버_연동하기_페이지: {
    path: '/settings/market-linkage/naver/login',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/naver/네이버_연동하기_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '네이버 연동하기',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  번개장터_연동하기_페이지: {
    path: '/settings/market-linkage/bunjang/login',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/bunjang/번개장터_연동하기_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '번개장터 연동하기',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  네이버_카테고리_연결_페이지: {
    path: '/settings/market-linkage/naver/category/edit',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/naver/네이버_카테고리_연결_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '네이버 카테고리 연결',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  번개장터_카테고리_연결_페이지: {
    path: '/settings/market-linkage/bunjang/category/edit',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/bunjang/번개장터_카테고리_연결_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '번개장터 카테고리 연결',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

export const 카페24_상세페이지_설정_라우터 = {
  상세설정_페이지: {
    path: '/settings/market-linkage/cafe24/platform-post/settings',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/cafe24/상세설정_페이지');
      return {
        Component: () => (
          <Page
            parents={[
              { ...쇼핑몰_연동_설정_페이지_라우터.index, handle: { title: '카페24' } },
              카페24_설정_라우터.상세페이지_설정,
            ]}
          />
        ),
      };
    },
    handle: {
      title: '상세설정 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

export const 카페24_설정_라우터 = {
  상세페이지_설정: {
    path: '/settings/market-linkage/cafe24/platform-post',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/cafe24/상세페이지_설정_페이지');
      return {
        Component: () => <Page parents={[{ ...쇼핑몰_연동_설정_페이지_라우터.index, handle: { title: '카페24' } }]} />,
      };
    },
    handle: {
      title: '상품글 양식 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  상품_게시_설정: {
    path: '/settings/market-linkage/cafe24/upload',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/cafe24/상품_게시_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품 게시 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
  상품정보_추가항목_입력: {
    path: '/settings/market-linkage/cafe24/additional-field',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/cafe24/상품정보_추가항목_입력_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품정보 추가항목/검색엔진 최적화(SEO) 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
  브랜드_코드_입력_설정: {
    path: '/settings/market-linkage/cafe24/brand-code',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/cafe24/브랜드_코드_입력_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '브랜드 코드 입력 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
  카테고리_관리: {
    path: '/settings/market-linkage/cafe24/category',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/cafe24/카테고리_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품 분류(카테고리) 관리',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

export const 네이버_설정_라우터 = {
  상품_게시_설정: {
    path: '/settings/market-linkage/naver/upload',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/naver/상품_게시_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품 게시 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
  상품_분류_관리: {
    path: '/settings/market-linkage/naver/category',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/naver/네이버_상품_분류_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품 분류(카테고리) 관리',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
  배송_설정: {
    path: '/settings/market-linkage/naver/shipping',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/naver/배송_반품_교환_및_AS_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '배송, 반품, 교환 및 A/S 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

/**
 * 쇼핑몰 설정 > 세컨솔드 탭 > 상품 게시 설정
 */
export const 세컨솔드_상품_게시_설정_라우터 = {
  상세페이지_설정: {
    path: '/settings/market-linkage/acloset/platform-post',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/acloset/상세페이지_설정_페이지');
      return {
        Component: () => <Page parents={[쇼핑몰_연동_설정_페이지_라우터.index]} />,
      };
    },
    handle: {
      title: '상품글 양식 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

/**
 * 쇼핑몰 설정 > 세컨솔드 탭 > 셀러 관리
 */
export const 세컨솔드_셀러_관리_라우터 = {
  프로필_설정: {
    path: '/settings/market-linkage/acloset/profile',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/프로필_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '프로필 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  현장결제_파트너샵_설정: {
    path: '/settings/market-linkage/acloset/partner-shop-setting',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/현장결제_파트너샵_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '오프라인 매장 홍보하기',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  리뷰_관리: {
    path: '/settings/market-linkage/acloset/review',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/리뷰_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '리뷰 관리',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  방해_고객_관리: {
    path: '/settings/market-linkage/acloset/black-consumers-management',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/방해_고객_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '방해 고객 관리',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

/**
 * 쇼핑몰 설정 > 세컨솔드 탭 > 할인 설정
 */
export const 세컨솔드_할인_설정_라우터 = {
  쿠폰_관리: {
    path: '/settings/market-linkage/acloset/coupon',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/쿠폰_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '쿠폰 관리',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  할인요청_설정: {
    path: '/settings/market-linkage/acloset/discount-offer',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/할인_요청_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '할인요청 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  카페24_할인정책_연계_설정: {
    path: '/settings/market-linkage/acloset/cafe24-discount-policy',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/acloset/카페24_할인정책_연계_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '카페24 할인정책 연계 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

/**
 * 쇼핑몰 설정 > 세컨솔드 탭 > 주문/배송 설정
 */
export const 세컨솔드_주문_배송_설정_라우터 = {
  배송비_반품_설정: {
    path: '/settings/market-linkage/acloset/shipping',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/acloset/배송비_및_반품_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '배송비 및 반품 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  배송_공지사항_설정: {
    path: '/settings/market-linkage/acloset/shipping-notice',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/배송_공지사항_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '배송 공지사항 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  알림_카톡받기: {
    path: '/settings/market-linkage/acloset/purchase-kakao-alarm',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/알림_카톡받기_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '주문/문의 알림 카톡받기',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

/**
 * 쇼핑몰 설정 > 세컨솔드 탭 > 정산 관리
 */
export const 세컨솔드_정산_관리_라우터 = {
  판매금_정산_계좌_설정: {
    path: '/settings/market-linkage/acloset/account',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/acloset/판매금_정산_계좌_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '판매금 정산 계좌 설정',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  판매_정산: {
    path: '/settings/market-linkage/acloset/settlement',
    async lazy() {
      const { default: Page } = await import('@/app/settlement/acloset/AclosetSettlementPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '판매 정산 내역 확인',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

export const 세컨솔드_설정_라우터 = {
  // 쇼핑몰 설정 > 세컨솔드 탭에 노출되는 라우트들
  ...세컨솔드_상품_게시_설정_라우터,
  ...세컨솔드_셀러_관리_라우터,
  ...세컨솔드_할인_설정_라우터,
  ...세컨솔드_주문_배송_설정_라우터,
  ...세컨솔드_정산_관리_라우터,

  // 쇼핑몰 설정 > 세컨솔드 탭에 노출되지 않는 라우트들
  세컨솔드_이미지: {
    path: '/settings/market-linkage/acloset/platform-post/acloset-image-register',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/acloset/세컨솔드_이미지_추가_페이지');
      return {
        Component: () => (
          <Page parents={[쇼핑몰_연동_설정_페이지_라우터.index, 세컨솔드_설정_라우터.상세페이지_설정]} />
        ),
      };
    },
    handle: {
      title: '세컨솔드 이미지 추가',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  쿠폰_생성하기: {
    path: '/settings/market-linkage/acloset/coupon/create',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/쿠폰_생성하기_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '쿠폰 생성하기',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

export const 번개장터_설정_라우터 = {
  상품_분류_관리: {
    path: '/settings/market-linkage/bunjang/category',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/bunjang/번개장터_상품_분류_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품 분류(카테고리) 관리',
    },
  } satisfies LookoRouteObject,
  배송_교환_설정: {
    path: '/settings/market-linkage/bunjang/shipping',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/bunjang/교환_및_배송_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '배송 설정',
    },
  } satisfies LookoRouteObject,
};

const 쇼핑몰_연동_설정_라우터: LookoRouteObject[] = [
  ...values(쇼핑몰_연동_설정_페이지_라우터),
  ...values(카페24_설정_라우터),
  ...values(네이버_설정_라우터),
  ...values(세컨솔드_설정_라우터),
  ...values(번개장터_설정_라우터),
  ...values(카페24_상세페이지_설정_라우터),
];

export default 쇼핑몰_연동_설정_라우터;
